import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-4 px-4 sm:px-6 bg-brand-plum" data-id="element-64" data-mp="1o3x1pk7r0m0y">
      <div className="bg-white border-2 border-brand-gold p-3.5 rounded-lg text-center shadow-md" data-id="element-65" data-mp="1o3dim06d3rlc">
        <p className="text-[11px] font-heading font-bold text-brand-pink uppercase tracking-widest" data-id="element-66" data-mp="221byxb48ty3h">
          Il tuo acquisto è protetto al 100%
        </p>
        <div className="w-11 h-11 mx-auto bg-brand-blush rounded-full flex items-center justify-center mt-1.5" data-id="element-67" data-mp="19dz8uqyvj85f">
          <ShieldCheckIcon className="w-6 h-6 text-brand-plum" data-id="element-68" data-mp="14gz3yjdrgbfw" />
        </div>
        <h3 className="font-display text-2xl sm:text-3xl tracking-wide text-brand-plum leading-none mt-1.5 uppercase" data-id="element-69" data-mp="1j4txu33i8luk">
          🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
        </h3>
        <p className="text-xs sm:text-sm text-brand-slate font-medium leading-snug mt-1.5" data-id="element-70" data-mp="qnpwwpdac20j">
          Il tuo acquisto è completamente senza rischi. Hai 14 giorni per esplorare tutti i moduli, utilizzare
          pianificazioni, esercizi, progressioni, programmi, valutazioni e strumenti professionali inclusi in RHYTHMIC
          GYM PRO™. Se per qualsiasi motivo non sarai completamente soddisfatto, ti basterà contattarci entro 14 giorni e
          riceverai il rimborso completo. Nessun rischio. Nessuna domanda.
        </p>
      </div>
    </section>;
}